import { FormattedMessage, useIntl } from 'react-intl'
import * as HeaderNavigationSubMenuStyles from '../../../../styles/foundation/HeaderNavigationSubMenu.css'
import { formattedMessageValues } from '../../../../utils/FormattedMessageValues'
import { HeaderNavigationSubMenuItem } from './ui/HeaderNavigationSubMenuItem'

type HeaderNavigationSubMenuProductProps = {
  packageEntity: Queries.Hygraph_GlobalNavigation['package']
  featureEntity: Queries.Hygraph_GlobalNavigation['feature']
}

export const HeaderNavigationSubMenuProduct = ({
  packageEntity,
  featureEntity,
}: HeaderNavigationSubMenuProductProps) => {
  const { messages } = useIntl()

  return (
    <>
      <div
        className={HeaderNavigationSubMenuStyles.Separator({
          size: 'wide',
        })}
      >
        <div className={HeaderNavigationSubMenuStyles.Headline}>
          <FormattedMessage
            id="components.foundation.header.nav.product.package.headline"
            defaultMessage="パッケージ"
            values={{ ...formattedMessageValues }}
          />
        </div>

        <ul
          className={HeaderNavigationSubMenuStyles.Links({
            type: 'package',
          })}
        >
          {packageEntity?.linkListing.map((item: any) => (
            <li key={item.name}>
              <HeaderNavigationSubMenuItem href={item.link} isBlank={item.isBlank} type="package" area={item.packageId}>
                <img
                  src={item.icon.url}
                  width="32"
                  height="32"
                  alt={
                    messages &&
                    typeof messages['components.foundation.header.nav.product.package.icon.alt'] === 'string'
                      ? `${item.name} ${messages['components.foundation.header.nav.product.package.icon.alt']}`
                      : `${item.name}アイコン`
                  }
                />
                <div>
                  <div className={HeaderNavigationSubMenuStyles.Links_PackagName}>{item.name}</div>
                  <p className={HeaderNavigationSubMenuStyles.Links_PackageCopy}>{item.copy}</p>
                </div>
              </HeaderNavigationSubMenuItem>
            </li>
          ))}
        </ul>
      </div>

      <div
        className={HeaderNavigationSubMenuStyles.Separator({
          size: 'wide',
          backgroundColor: 'alpha',
        })}
      >
        <div className={HeaderNavigationSubMenuStyles.Headline}>
          <FormattedMessage
            id="components.foundation.header.nav.product.feature.headline"
            defaultMessage="機能"
            values={{ ...formattedMessageValues }}
          />
        </div>

        <dl
          className={HeaderNavigationSubMenuStyles.Links({
            type: 'feature',
          })}
        >
          {featureEntity?.linkGroupListing.map((groupItem: any) => (
            <div
              key={groupItem.headline}
              className={HeaderNavigationSubMenuStyles.Links_GroupItem({
                area: groupItem.groupId,
              })}
            >
              <dt className={HeaderNavigationSubMenuStyles.Links_FeatureHeadline}>{groupItem.headline}</dt>
              {groupItem.linkListing.map((item: Queries.Hygraph_GlobalNavigationStandardItem) => (
                <dd
                  key={item.label}
                  style={{
                    fontSize: 0,
                  }}
                >
                  <HeaderNavigationSubMenuItem href={item.link} isBlank={item.isBlank} type="simple">
                    {item.label}
                  </HeaderNavigationSubMenuItem>
                </dd>
              ))}
            </div>
          ))}
        </dl>
      </div>
    </>
  )
}
